import React, { useCallback, useMemo } from 'react'
import { Grid, makeStyles } from '@material-ui/core'
import DazzedParagraph14 from 'components/common/text/DazzedParagraph14'
import { useTranslation } from 'react-i18next'
import { conditionTypes, MIN_ALIGNER_INTERVAL } from 'consts/automatedActionConsts'
import { APPLIANCE_SETS_MAX_NUMBER } from 'consts/treatmentConsts'
import ErrorMessage from 'components/common/text/ErrorMessage'

const useStyles = makeStyles({
  intervalInput: {
    outline: 'none',
    fontSize: 16,
    textAlign: 'center',
    height: 32,
    width: 80,
    border: 'none',
    borderBottom: ({ errorMessage }) => (errorMessage ? '1px solid red' : '1px solid var(--border-color-11)'),
    paddingLeft: 14
  }
})

const AlignerNumberEveryCondition = ({ onChange, params, errors }) => {
  const errorMessage = useMemo(() => errors.conditions?.[conditionTypes.AlignerNumberEvery], [errors])
  const classes = useStyles({ errorMessage })
  const { t } = useTranslation()

  const handleChange = useCallback(
    alignerInterval => {
      onChange({
        type: conditionTypes.AlignerNumberEvery,
        params: { alignerInterval }
      })
    },
    [onChange]
  )

  return (
    <Grid container direction="column">
      <Grid item>
        <Grid container alignItems="center">
          <Grid item>
            <DazzedParagraph14 strong>
              {t('pages.accountSettings.automations.editorModal.enterAlignerInterval')}
            </DazzedParagraph14>
          </Grid>
          <Grid item>
            <input
              value={params?.alignerInterval || ''}
              type="number"
              inputMode="numeric"
              pattern="[0-9]*"
              placeholder={t('pages.accountSettings.automations.editorModal.enterAlignerIntervalPlaceholder')}
              className={classes.intervalInput}
              onChange={({ target }) => handleChange(target.value)}
              min={MIN_ALIGNER_INTERVAL}
              max={APPLIANCE_SETS_MAX_NUMBER}
            />
          </Grid>
        </Grid>
      </Grid>
      <Grid item>{errorMessage && <ErrorMessage text={errorMessage} active={!!errorMessage} />}</Grid>
    </Grid>
  )
}

export default AlignerNumberEveryCondition
